import { Component } from '@angular/core';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { PersonalModel } from 'libs/core/src/lib/model/personal.model';
import { PersonalPageComponent } from 'libs/shared/src/lib/page/personal/personal.component';

export enum PersonalStateEnum {
  Initial = 'initial',
  Success = 'success',
  Failed = 'failed'
}

@Component({ standalone: false, selector: 'app-page-personal', templateUrl: './personal.component.html' })
export class CustomPersonalPageComponent extends PersonalPageComponent {
  onPersonalFormEvent(personalData: PersonalModel): void {
    if (personalData) {
      const updateModel = this.order.toApiModel();
      updateModel.userEmail = personalData.email;
      updateModel.userFirstName = personalData.firstName;
      updateModel.userLastName = personalData.lastName;
      updateModel.userPhone = personalData.phone;

      this.orderDataProvider.update(this.order.cinemaId, updateModel).subscribe();
    }
  }

  public onNavigationClick(event: string) {
    switch (event) {
      case 'previous':
        this.navigationService.goTo([this.navigationHelper.getPreviousRoute(this.route.snapshot)]);
        break;
      case 'next':
        this.loaderService.showLoader(LoaderEnum.NEXT_BUTTON);

        this.putOrderAgreements(this.getBasketAgreements(true)).subscribe();

        if (this.personalComponent) {
          this.personalComponent.onSubmitObservable().subscribe({
            next: (result) => {
              this.loaderService.hideLoader(LoaderEnum.NEXT_BUTTON);
              if (result) {
                this.navigationService.goTo([this.navigationHelper.getNextRoute(this.route.snapshot)]);
              }
            },
            complete: () => {
              this.loaderService.hideLoader(LoaderEnum.NEXT_BUTTON);
            }
          });
        }
        break;
    }
  }
}
